<app-header pageTitle="{{ 'private-ticket.pageTitle' | translate }}" (back)="navigateToSyndicateTab()"></app-header>
<ion-content>
  <div class="heading-wrapper">
    <h1 class="txt-clr-light-blue syndicate-name">
      {{ syndicateDetails?.ps_name }}
    </h1>
  </div>
  @if (ticketData) {
    <div class="page-background-blue upper-content-wrap">
      @if (showSlides) {
        <swiper #slides [config]="getSliderOptions(ticketData)" #syndicateTicketsSlider>
          @if (ticketData && ticketData?.length) {
            @for (ticket of ticketData; track ticket; let i = $index) {
              <ng-template swiperSlide>
                <ion-card class="ticket-card-size" [@flipIn]="showFlip ? 'start' : ' '">
                  <ion-grid class="ticket-card-wrapper">
                    <ion-row class="jackpot-details-row">
                      <ion-col size="1.5" class="jackpot-logo-wrap">
                        <img class="jackpot-logo" src="{{ ticket?.ticketLines[0].product_image }}" alt="product-image" />
                      </ion-col>
                      <ion-col size="6.5">
                        <h3 class="jackpot-name ion-text-left">{{ ticket?.ticketLines[0]?.product_name }}</h3>
                        <p class="lines-available ion-text-left">
                          {{ ticket?.ticketLines[0]?.draw_day }}
                        </p>
                      </ion-col>
                      <ion-col size="4" class="jackpot-right-wrap">
                        <h1 class="syndicate-name txt-clr-light-blue ion-text-right txt-players">
                          {{ "private-ticket.Share" | translate }}
                        </h1>
                        @if (viewText && !dotAnimation) {
                          <p
                            class="view-players link-text-blue"
                            (click)="viewPlayers(ticketData)"
                            >
                            {{ "private-ticket.view" | translate }}
                          </p>
                        }
                        @if (!viewText) {
                          <p class="player-number">{{ syndicateCount == "0" ? "-" : syndicateCount }}</p>
                        }
                        @if (dotAnimation) {
                          <app-dot-flash-animation></app-dot-flash-animation>
                        }
                      </ion-col>
                    </ion-row>
                    @if (ticket?.ticketLines && ticket?.ticketLines?.length) {
                      <div class="ticket-number-wrap">
                        @for (ticketRow of ticket?.ticketLines; track ticketRow; let i = $index; let oddRow = $odd; let evenRow = $even) {
                          <ion-row
                            class="ticket-number-row"
                            [ngClass]="{ 'ticket-number-row-opacity': createSyndicate && (i === 2 || i === 3) }"
                            >
                            <ion-col class="ion-no-padding" size="1.5">
                              <!-- <h1 class="ticket-serial">{{ alphabeticOrder(i) }}</h1> -->
                              <img
                                [src]="loadUserProfile(ticketRow?.user_id)"
                                alt="profilePic"
                                style="border-radius: 50%; height: 3vh; width: 3vh"
                                (click)="showProfilePopup(ticketRow?.user_id)"
                                />
                              </ion-col>
                              @if (showLines) {
                                @for (mainNumber of ticketRow?.regularNumbers; track mainNumber; let colIndex = $index) {
                                  <ion-col
                                    class="ion-no-padding"
                                    [ngClass]="{ 'background-color': oddRow && checkedTicket }"
                                    >
                                    <h1 class="ticket-number">
                                      {{ mainNumber }}
                                    </h1>
                                  </ion-col>
                                }
                                @for (bonusNumber of ticketRow?.bonusNumbers; track bonusNumber; let odd = $odd; let yellowIndex = $index) {
                                  <ion-col
                                    class="ion-no-padding"
                                    [ngClass]="{ 'background-color': oddRow && checkedTicket }"
                                    >
                                    <h1 class="ticket-number golden-ticket-number">
                                      {{ bonusNumber }}
                                    </h1>
                                  </ion-col>
                                }
                              }
                              @if (!showLines) {
                                <ion-col size="9" class="ion-no-padding">
                                  <h1 class="ticket-number-raffel">{{ ticketRow?.raffle }}</h1>
                                </ion-col>
                              }
                              @if (ticketRow?.eye) {
                                <ion-col class="ion-no-padding">
                                  <ion-icon name="eye" class="ticket-camera-icon" (click)="setTicket(ticketRow?.eye)"></ion-icon>
                                </ion-col>
                              }
                            </ion-row>
                          }
                        </div>
                      }
                      <div class="ticket-footer-content">
                        <div class="ticket-section">
                          <ion-row class="total-lines-wrapper">
                            <ion-col>
                              <p class="total-lines">{{ "private-ticket.Total" | translate }}</p>
                            </ion-col>
                            <ion-col>
                              <p class="no-of-lines">{{ getLines(ticket) }} {{ "private-ticket.Line" | translate }}</p>
                            </ion-col>
                          </ion-row>
                          @if (ticket?.raffle && isRaffleAvailable(i)) {
                            <ion-row class="ticker-viwe-million">
                              @if (showLines) {
                                <p class="view-millionaire-makers" (click)="switchMode()">
                                  {{ "private-ticket.Millionaire" | translate }}
                                </p>
                              }
                              @if (!showLines) {
                                <p class="view-millionaire-makers" (click)="switchMode()">
                                  {{ "private-ticket.lines" | translate }}
                                </p>
                              }
                            </ion-row>
                          }
                          <ion-row>
                            @if (syndicateDetails?.syndicate_id != null) {
                              <div>
                                <ion-button class="proceed-btn" (click)="openSyndicates()">
                                  {{ "private-ticket.Proceed" | translate }}</ion-button
                                  >
                                </div>
                              }
                            </ion-row>
                          </div>
                        </div>
                      </ion-grid>
                    </ion-card>
                  </ng-template>
                }
              }
              @if (!listProduct?.products && !listProduct?.products?.length) {
                <div class="no-ticket-wrapper">
                  <span class="magnifying-emoji">🔎</span>
                  <p>
                    {{ "private-ticket.tickets" | translate }}<br />{{ "private-ticket.think" | translate }}
                    <span class="link-text-blue" (click)="openHelpTab()"> {{ "private-ticket.contact" | translate }}</span>
                  </p>
                </div>
              }
            </swiper>
          }
        </div>
      } @else {
        <app-in-progress-animation></app-in-progress-animation>
      }
    </ion-content>
    @if (syndicateTicketSource !== 'syndicateTab' && syndicateTicketSource !== 'Invitation') {
      <ion-footer
        class="ion-no-border"
        >
        <ion-button class="proceed-btn" (click)="goToSyndicateTab()">{{ "private-ticket.Proceed" | translate }}</ion-button>
      </ion-footer>
    }
